import Vue from 'vue'
import axios from 'axios'
import VueI18n from 'vue-i18n'
// 引入COOKUI多语言
import zhCookMessages from '@gcommon/gcommon-ui/lib/locale/lang/zh-CN'
import enCookMessages from '@gcommon/gcommon-ui/lib/locale/lang/en'
import { getStorage, getBrowserLang,setStorage } from '../utils/assist'

// const modules = import.meta.globEager('/*.json')

function getLang() {
  return getStorage('lang') || getBrowserLang()
}
if (import.meta.env.MODE === 'development') {
  //判断环境使用不一样的翻译文件来源
}
Vue.use(VueI18n)
const messages = {
  en: {
    ...window.langenUS,
    ...enCookMessages
  },
  zh: {
    ...window.langzhCN,
    ...zhCookMessages
  },
  id:{
    ...window.langidID,
    ...enCookMessages
  }
}
const i18n = new VueI18n({
  locale: getLang(), // 设置地区
  messages // 设置地区信息
})

export default i18n
